/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_yt_shorts_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tap Share on the Short and copy the link, or copy it from the address bar. It will contain /shorts/ followed by the video ID.`)
};

const es_yt_shorts_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Toca Compartir en el Short y copia el enlace, o cópialo desde la barra de direcciones. Contendrá /shorts/ seguido del ID del video.`)
};

const de_yt_shorts_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tippe im Short auf Teilen und kopiere den Link, oder kopiere ihn aus der Adressleiste. Er enthält /shorts/ gefolgt von der Video-ID.`)
};

const nl_yt_shorts_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tik op Delen bij de Short en kopieer de link, of kopieer hem uit de adresbalk. Deze bevat /shorts/ gevolgd door het video-ID.`)
};

const fr_yt_shorts_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Appuyez sur Partager sur le Short et copiez le lien, ou copiez-le depuis la barre d’adresse. Il contiendra /shorts/ suivi de l’ID de la vidéo.`)
};

const it_yt_shorts_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tocca Condividi sullo Short e copia il link, oppure copialo dalla barra degli indirizzi. Conterrà /shorts/ seguito dall'ID del video.`)
};

const pt_br2_yt_shorts_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Toque em Compartilhar no Short e copie o link, ou copie-o da barra de endereço. Ele vai conter /shorts/ seguido pelo ID do vídeo.`)
};

const pt_yt_shorts_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Toque em Partilhar no Short e copie o link, ou copie-o da barra de endereço. Vai conter /shorts/ seguido do ID do vídeo.`)
};

const ja_yt_shorts_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Short動画の「共有」をタップしてリンクをコピーするか、アドレスバーからコピーしてください。リンクには/shorts/の後に動画IDが含まれます。`)
};

const zh_yt_shorts_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`点击 Short 上的分享按钮复制链接，或从地址栏复制。链接中会包含 /shorts/ 加上视频 ID。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const yt_shorts_faq2_a = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.yt_shorts_faq2_a(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("yt_shorts_faq2_a", locale)
	if (locale === "en") return en_yt_shorts_faq2_a(inputs)
	if (locale === "es") return es_yt_shorts_faq2_a(inputs)
	if (locale === "de") return de_yt_shorts_faq2_a(inputs)
	if (locale === "nl") return nl_yt_shorts_faq2_a(inputs)
	if (locale === "fr") return fr_yt_shorts_faq2_a(inputs)
	if (locale === "it") return it_yt_shorts_faq2_a(inputs)
	if (locale === "pt-BR") return pt_br2_yt_shorts_faq2_a(inputs)
	if (locale === "pt") return pt_yt_shorts_faq2_a(inputs)
	if (locale === "ja") return ja_yt_shorts_faq2_a(inputs)
	return zh_yt_shorts_faq2_a(inputs)
};